import { render, staticRenderFns } from "./ClockWidget.vue?vue&type=template&id=37071156&"
import script from "./ClockWidget.vue?vue&type=script&lang=js&"
export * from "./ClockWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports